import React, { Component } from "react";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import { Image } from "react-bootstrap";
class CustomDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null,
      withoutTrimOption: null
    };
    this.dropdownRef = React.createRef();
    this.dropdownObserver = null; // store observer here
  }

  componentDidMount() {
    this.observeDropdownChanges();
    const { resetForm } = this.props;
  }

  componentDidUpdate() {
    this.observeDropdownChanges();
  }

  componentWillUnmount() {
    if (this.state.dropdownObserver) {
      this.state.dropdownObserver.disconnect();
    }
  }
  observeDropdownChanges = () => {
    // Replace optional chaining with normal checks
    const dropdownContainer = this.dropdownRef.current;
    if (!dropdownContainer) return;

    const dropdownRoot = dropdownContainer.querySelector(".Dropdown-root");
    if (!dropdownRoot) return;

    // disconnect old observer to avoid multiple triggers
    if (this.state.dropdownObserver) {
      this.state.dropdownObserver.disconnect();
    }

    const observer = new MutationObserver(() => {
      const isOpen = dropdownRoot.classList.contains("is-open");
      if (isOpen) {
        this.attachHoverListeners();
      }
    });

    observer.observe(dropdownRoot, {
      attributes: true,
      attributeFilter: ["class"]
    });

    this.dropdownObserver = observer;
  };

  attachHoverListeners = () => {
    const { menuClassName } = this.props;
    const dropdownMenu = document.querySelector(`.${menuClassName}`);
    if (!dropdownMenu) return;
    const selectedOptionEl = dropdownMenu.querySelector(".is-selected");

    const options = dropdownMenu.querySelectorAll(".Dropdown-option");
    if (!options.length || !selectedOptionEl) return;

    // Clean up old listeners to prevent duplicates
    options.forEach(opt => {
      opt.removeEventListener("mouseenter", this.handleMouseEnter);
      opt.removeEventListener("mouseleave", this.handleMouseLeave);
    });

    // 🟢 Mouse enter logic
    this.handleMouseEnter = e => {
      const hovered = e.currentTarget;

      // Remove previous hover classes
      dropdownMenu
        .querySelectorAll(".Dropdown-option.is-hovered")
        .forEach(opt => {
          opt.classList.remove("is-hovered");
        });

      // Always clear any previous hover-active class
      selectedOptionEl.classList.remove("is-hovered-active");

      // 🧩 If hovered option is NOT the selected one
      if (!hovered.classList.contains("is-selected")) {
        hovered.classList.add("is-hovered");
        // Apply hover-active class to selected option
        selectedOptionEl.classList.add("is-hovered-active");
      } else {
        // If hovering the selected option itself → ensure hover-active is removed
        selectedOptionEl.classList.remove("is-hovered-active");
      }
    };

    // Attach listeners
    options.forEach(opt => {
      opt.addEventListener("mouseenter", this.handleMouseEnter);
      opt.addEventListener("mouseleave", this.handleMouseLeave);
    });
  };
  _onSelect = option => {
    const {
      page,
      options,
      bucketId,
      idx,
      fetchGetPragatiProject,
      onChange
    } = this.props;

    this.setState({ selectedOption: option });

    // Case 1: Fetch Pragati Project
    if (fetchGetPragatiProject) return fetchGetPragatiProject(option.value);

    // Case 2: Direct simple handlers
    const simpleHandlers = {
      "create-agenda": () => onChange(option),
      "dashboard-projectbysponsor": () =>
        onChange(option.value, "projectGroupCategorySelect"),
      "dashboard-projectbylocation": () =>
        onChange(option.value, "projectLocationGroupCategorySelect"),
      "dashboard-projectstagewise": () => onChange(option.value, "stage_wise"),
      "dashboard-averagedelay": () => onChange(option.value, "average_delay"),
      "dashboard-issuepending": () =>
        onChange(option.value, "issuesGroupCategorySelect"),
      "dashboard-pragatiprojects": () =>
        onChange(option.value, "pragatiProjectSelectBy"),
      "reassign-for-clarification": () => onChange(option.value, "to"),
      "dashboard-pendingissue-category": () =>
        onChange(option.value, "issuesByCategorySelectBy"),
      "user-group": () => onChange(option.value, "category"),
      cms: () => onChange(option.value),
      "implementation-mode": () => onChange(option.value, "implementationMode"),
      "issue-action": () => onChange(option.value, "status"),
      "select-summary-state": () => onChange(option.value),
      "select-monitering-state": () => onChange(option.value),
      "select-meeting-type": () => onChange(option.value),
      "create-project-select-ministry": () => onChange(option.value),
      "create-project-select-division": () => onChange(option.value),
      "create-project-select-sector": () => onChange(option.value),
      "mark-duplicate-select-issue": () => onChange(option.value, "to"),
      "create-agenda-form-venue-dropdown": () =>
        onChange(option.value, "venue"),
      "edit-agenda-form-venue-dropdown": () => onChange(option.value, "venue")
    };

    if (simpleHandlers[page]) return simpleHandlers[page]();

    // Case 3: Pages needing lookup by label
    var found = options && options.find(item => item.label === option.value);
    if (!found) return;

    // Config-driven handling for mapping
    const pageMap = {
      "create-issue": "issueCategoryId",
      "create-issue-centralministry": "selectedMinistryId",
      issueSubcategory: "issueSubCategoryId",
      projectStage: "bucketId",
      selectPhase: "milestoneTableId",
      "milestone-activity": "milestoneId",
      "issue-district": "stateDistrictAndDepartment",
      "issue-state": "selectedStateId",
      "create-project-division": "divisionId",
      "create-project-scheme": "schemeId",
      "create-project-sponsoring-agency": "sponsoringAgency",
      "create-project-sponsoring-dept": "sponsoringDepartmentId",
      "create-project-subsector": "subSectorId",
      "create-project-groupid": "groupId",
      "create-project-district": "sponsoringDepartmentId",
      "create-project-sector": "sectorId",
      "create-project-implementation-mode": "implementationMode",
      "create-agenda-form-venue-dropdown": "venue"
    };

    const key = pageMap[page];
    if (!key) return;

    // Truncate only for projectStage
    if (page === "projectStage") {
      this.setState({ selectedOption: option.value.slice(0, 46) });
    } else if (
      page === "issueSubcategory" ||
      page === "create-issue" ||
      page === "create-issue-centralministry" ||
      page === "issue-action" ||
      page === "issue-state" ||
      page === "select-summary-state" ||
      page === "select-monitering-state" ||
      page === "select-meeting-type" ||
      page === "create-agenda-form-venue-dropdown" ||
      page === "edit-agenda-form-venue-dropdown"
    ) {
      this.setState({ selectedOption: option.value });
    }

    // Handle extra argument only for selectPhase
    if (page === "selectPhase") {
      return onChange(found.id, key, idx, bucketId);
    }

    return onChange(found.id, key, idx);
  };

  displayValue() {
    const { page, value, options, isEdit, resetForm } = this.props;
    const { selectedOption } = this.state;
    const defaultOption = (options && options[0]) || null;

    if (resetForm) return null;

    // Pages that simply return value or selectedOption/default
    const simplePages = [
      "create-agenda",
      "dashboard",
      "dashboard-projectbysponsor",
      "dashboard-projectbylocation",
      "dashboard-projectstagewise",
      "dashboard-averagedelay",
      "dashboard-issuepending",
      "dashboard-pragatiprojects",
      "reassign-for-clarification",
      "dashboard-pendingissue-category",
      "user-group",
      "cms",
      "projectStage",
      "implementation-mode",
      "issue-district",
      "issue-state",
      "select-summary-state",
      "select-monitering-state",
      "select-meeting-type",
      "create-project-select-ministry",
      "create-project-select-division",
      "create-project-select-sector",
      "mark-duplicate-select-issue",
      "edit-agenda-venue",
      "create-agenda-form-venue-dropdown",
      "edit-agenda-form-venue-dropdown"
    ];

    if (simplePages.includes(page)) {
      if (
        page === "projectStage" ||
        page === "implementation-mode" ||
        page === "issue-district"
      ) {
        return isEdit === undefined ? selectedOption || defaultOption : value;
      }
      return value || selectedOption || defaultOption;
    }

    // Common reusable check for pages that validate options
    const validateOption = () => {
      const exists = options && options.some(item => item.value === value);
      if (!exists) return defaultOption;
      if (isEdit === undefined) return selectedOption || defaultOption;
      if (value == null) return value;
      if (selectedOption == null && value === "")
        return selectedOption || defaultOption;
      return value;
    };

    // Pages with option validation
    const validatePages = [
      "issueSubcategory",
      "selectPhase",
      "milestone-activity"
    ];
    if (validatePages.includes(page)) return validateOption();

    // create-issue page
    if (
      page === "create-issue" ||
      page === "create-issue-centralministry" ||
      page === "issue-action"
    ) {
      if (isEdit === undefined) return selectedOption || defaultOption;
      return value; // value can be null or valid, same return both cases
    }

    return defaultOption; // Fallback
  }

  render() {
    const {
      options,
      height,
      width,
      className,
      page,
      menuClassName,
      error,
      disabled,
      DropdownArrow,
      loading,
      marginRight
    } = this.props;
    const { selectedOption } = this.state;
    var defaultOption = options && options.length > 0 ? options[0].value : null;
    return (
      <div style={{ width, height, marginRight }} ref={this.dropdownRef}>
        <Dropdown
          options={options}
          onChange={this._onSelect}
          value={this.displayValue()}
          placeholder={defaultOption}
          className={error ? `${className} mandatory-error` : className}
          menuClassName={menuClassName}
          disabled={disabled}
          {...(page === "user-group" || page === "cms") && {
            arrowClosed: (
              <div
                className="user-group-dropdown-arrow"
                style={{ marginTop: page === "cms" ? "-1.4em" : "-1.2em" }}
              >
                <Image src={DropdownArrow} alt="arrow" width={14} height={14} />
              </div>
            ),
            arrowOpen: (
              <div
                className="user-group-dropdown-arrow"
                style={{ marginTop: page === "cms" ? "-1.4em" : "-1.2em" }}
              >
                <Image
                  src={DropdownArrow}
                  alt="arrow"
                  width={14}
                  height={14}
                  className="rotate-180 transition-transform duration-200"
                />
              </div>
            )
          }}
        />
      </div>
    );
  }
}

export default CustomDropdown;
